export const Logo = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" aria-hidden="true">
    <rect x="0.5" y="0.5" width="27" height="27" fill="#09090b" />
    <path d="M6 9.5 L14 15.5 L22 9.5" stroke="#fafafa" strokeWidth="2" fill="none" strokeLinecap="square" />
    <path d="M6 9.5 V20 H16" stroke="#fafafa" strokeWidth="2" fill="none" strokeLinecap="square" />
    <rect x="18" y="17" width="5" height="5" fill="#e11d48" />
  </svg>
);
